import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancelled() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const reportId = params.get("report_id");

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center text-center" data-testid="payment-cancelled-page">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
        <XCircle className="h-9 w-9 text-slate-500" />
      </div>
      <h1 className="mt-6 font-heading text-2xl font-semibold tracking-tight" data-testid="payment-cancelled-title">Payment cancelled</h1>
      <p className="mt-2 text-slate-600" data-testid="payment-cancelled-message">Payment cancelled. You can try again.</p>
      <div className="mt-8 flex gap-3">
        {reportId && (
          <Button variant="outline" onClick={() => navigate(`/results/${reportId}`)}>Back to my results</Button>
        )}
        <Button className="gap-2" onClick={() => navigate(reportId ? `/results/${reportId}` : "/pricing")} data-testid="payment-cancelled-retry">
          Try again <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
